import { render, staticRenderFns } from "./recommendedList.vue?vue&type=template&id=7bc4ebf3&scoped=true"
import script from "./recommendedList.vue?vue&type=script&lang=js"
export * from "./recommendedList.vue?vue&type=script&lang=js"
import style0 from "./recommendedList.vue?vue&type=style&index=0&id=7bc4ebf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4ebf3",
  null
  
)

export default component.exports